import { LitElement, html, css } from 'lit-element';
import { FBP } from '@furo/fbp';
import '@furo/layout/src/furo-vertical-scroller';
import '@furo/input/src/furo-icon-button.js';
import '@furo/data/src/furo-deep-link.js';
import '@furo/app/src/furo-loading-indicator-bar.js';
import './bes-filter.js';
import './bes-item.js';

/**
 * `bes-list`
 * Describe your element
 *
 * @summary shortdescription
 * @customElement
 * @demo demo/bes-list.html
 * @appliesMixin FBP
 */
class BesList extends FBP(LitElement) {
  constructor() {
    super();

    this._FBPAddWireHook('--collectionResponse', e => {
      if (typeof e.data === 'undefined') {
        this.titel = '';
      } else {
        this.titel = e.data[0].data.display_supportcase;
      }
    });
  }

  /**
   *
   * @private
   * @return {CSSResult}
   */
  static get styles() {
    // language=CSS
    return css`
      :host {
        display: block;
        height: 100%;
        width: var(--kachel-breite);
        padding: 24px 0;
        background-color: var(--surface, white);
        box-sizing: border-box;
      }

      .date {
        border-top: 1px solid gainsboro;
        position: sticky;
        top: 0;
        background-color: whitesmoke;
        height: 40px;
        line-height: 40px;
        box-sizing: border-box;
        padding-left: 12px;
        padding-right: 12px;
        z-index: 1;
      }

      .date span {
        float: right;
      }

      furo-icon-button {
        background-color: var(--primary);
        border-radius: 50%;
        color: var(--on-primary);
        margin: 12px;
      }

      .sc {
        color: var(--primary);
        line-height: 64px;
        font-size: 20px;
        text-align: center;
      }

      bes-item[selected] {
        background-color: rgba(26, 127, 240, 0.18);
      }
    `;
  }

  /**
   * Exposes --reload-list
   * @param {*} det
   */
  reloadList(det) {
    this._FBPTriggerWire('--reload-list', det);
  }

  setQp(qp) {
    this._FBPTriggerWire('--qpIn', qp);
  }

  /**
   * @private
   * @returns {TemplateResult}
   */
  render() {
    // language=HTML
    return html`
      <furo-vertical-flex>
        <furo-horizontal-flex>
          <bes-filter flex @-new-filter="--newFilter"></bes-filter>
          <furo-icon-button
            class="primary"
            icon="add"
            @-click="^^add-bestellung-clicked(injectedHTS),--addClicked"
          ></furo-icon-button>
        </furo-horizontal-flex>
        <furo-vertical-scroller flex @-list-item-clicked="--itemSelected">
          <furo-loading-indicator-bar
            ƒ-start="--htsInjected, --reload-list"
            ƒ-stop="--collectionResponse"
          ></furo-loading-indicator-bar>
          <template
            is="flow-repeat"
            ƒ-inject-items="--collectionResponse(*.entities)"
            ƒ-select="--itemSelected"
            ƒ-deselect="--addClicked"
          >
            <bes-item
              ƒ-inject="--item"
              ƒ-select="--itemSelected"
              ƒ-deselect="--itemDeSelected"
              ƒ-clear-date="--firstItem"
              ƒ-.index="--index"
            ></bes-item>
          </template>
        </furo-vertical-scroller>
      </furo-vertical-flex>

      <!-- injectedHTS wird parkiert um es nachher mit dem event add-bestellung-clicked zu schicken-->
      <furo-deep-link
        service="Bestellung"
        ƒ-qp-in="--qpIn"
        @-hts-out="--hts,((injectedHTS))"
      ></furo-deep-link>

      <!-- Marc: wenn du list aktivierst kippt der server -->
      <furo-collection-agent
        service="Bestellung"
        ƒ-set-filter="--newFilter"
        @-filter-changed="--filterChanged"
        ƒ-hts-in="--hts"
        @-hts-injected="--htsInjected"
        ƒ-list="--htsInjected, --reload-list, --filterChanged"
        @-response="--collectionResponse"
      ></furo-collection-agent>
    `;
  }
}

window.customElements.define('bes-list', BesList);
